<template>
    <div :class="{
                'hd-update p-0': true,
                'position-relative': $detect == 'web',
                'hd-update-mobile': $detect == 'mobile'
            }">
        <div>
            <div class="title border-bottom border-primary">
                <div class="d-flex justify-content-between">
                    <div :class="{
                        'py-10px px-3': $detect == 'web',
                        'pt-1 pb-2': $detect == 'mobile',
                        'fw-600' : true
                    }">Hộp thư đến</div>
                    <div class="btn-update" role="button" @click="activeUpdate = true" v-if="hoidap.update_status">
                        <i class="icon ion-md-create mr-2"></i>Chỉnh sửa
                    </div>
                </div>
            </div>
            <div :class="{
                    'body': true,
                    'p-3': $detect == 'web'
                }">
                <div class="title-faq">
                    <p class="mb-0">Người gửi: {{ hoidap.sender_loginname }}</p>
                </div>
                <div class="category-faq mt-3">
                    <p class="mb-0">{{ hoidap.title}}</p>
                </div>
                <div class="des-faq mt-3" v-html="hoidap.content">
                </div>
            </div>
        </div>
        
    </div>
</template>

<script>
export default {
    components: {
        editor: () => import('@/components/editor/index'),
    },
    data() {
        return {
            hoidap: [],
        }
    },
    watch: {
        
    },
    created() {
        this.getHoidap();
    },
    methods: {
        getHoidap() {
            apiGet('/v2/message/' + this.$route.params.id).then((res) => {
                this.hoidap = res.data;
            }).catch((err) =>{
                
            })
        }
    }
}
</script>

<style lang="scss">
    .hd-update {
        min-height: calc(100vh - 115px);
        .title {
            .btn-update {
                color:#007bff;
                font-size: 14px;
                padding: 11px 16px;
                &:hover {
                    text-decoration: underline;
                }
            }
        }
        .hd-edit {
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            background: rgba(240, 245, 249, 0.8);
            .content-edit {
                box-shadow: 0 4px 25px 0 rgba(0, 0, 0, 0.1);
                border-radius: 4px;
                .body {
                    .input-titile {
                        height: 40px;
                        border: 1px solid rgba(0, 0, 0, 0.2);
                        &:focus {
                            outline: none !important;
                        }
                    }
                    .hd-list-category {
                        .dropdown-category {
                            height: 40px;
                            background: #fff;
                            border: 1px solid rgba(0, 0, 0, 0.2);
                            border-radius: 4px;
                        }
                        .input-icon {
                            position: relative;
                            input {
                                width: 100%;
                                background-color: white;
                                border-radius: 4px;
                                border: 1px solid rgba(0, 0, 0, 0.1);
                                padding: 0 40px 0 10px;
                                transition: border 0.2s ease-in;
                                height: 40px;
                                &:focus {
                                    border-color: #2979ff;
                                    box-shadow: none !important;
                                    outline: none !important;
                                }
                            }
                            i {
                                color: #000;
                                font-size: 20px;
                                position: absolute;
                                right: 14px;
                                top: 50%;
                                transform: translateY(-50%);
                            }
                        }
                        .list-category {
                            height: 350px;
                            overflow-y: auto;
                        }
                        .unset-height {
                            height: unset !important;
                        }
                    }
                    .text-placeholder-category {
                        color: #777;
                    }
                    .input-validate {
                        &::placeholder {
                            color: #dc3545;
                        }
                    }
                    .line-loading {
                        width: 100%;
                        height: 3px;
                        position: relative;
                        margin: -8px auto 10px;
                        &:before {
                            content: "";
                            position: absolute;
                            right: auto;
                            left: 0;
                            height: 100%;
                            background-color: #0c81f6;
                            animation: lineLoading 1s forwards infinite linear;
                        }
                    }
                    @keyframes lineLoading {
                        0% {
                            right: 100%;
                        }

                        50% {
                            right: 0;
                            left: 0;
                        }

                        100% {
                            right: 0;
                            left: 100%;
                        }
                    }
                }
            }
        }
    }
    .hd-update-mobile {
        .btn-update {
            padding: 5px 0 8px !important;
        }
        .title-faq {
            margin-top: 10px;
        }
        .form-edit {
            .body {
                padding: 10px !important;
            }
        }
        .title-edit {
            background-color: #007bff;
            color: #fff;
            padding: 10px !important;
            .close {
                color: #fff;
            }
        }
    }
</style>
